import { Grid } from '@mui/material'
import StatCard from './StatCard'

const RenderKPIs = ({
  dealsEndingSoonCount,
  contractsSentCount,
  dealsWonCount,
}: {
  dealsEndingSoonCount: number
  contractsSentCount: number
  dealsWonCount: number
}) => {
  return (
    <>
      <Grid item xs={6} md={3}>
        <StatCard label="Deals Ending ≤30d" value={dealsEndingSoonCount} hint="Deals with any product ending soon" />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard label="Contracts Sent (mo)" value={contractsSentCount} hint="This month, owned by you" />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard label="Deals Won" value={dealsWonCount} hint="Total deals won" highlight />
      </Grid>
    </>
  )
}
export default RenderKPIs
